import type { ReactNode } from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { cn } from '@/lib/cn';
import { formatDeltaPct } from '@shared/format';

/** Signed delta chip with directional arrow. By default an increase reads as
 *  positive (green); pass invert for metrics where down is good (e.g. losses). */
export function Delta({ value, invert = false, className }: { value: number; invert?: boolean; className?: string }) {
  const good = invert ? value < 0 : value > 0;
  const Icon = value >= 0 ? ArrowUpRight : ArrowDownRight;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-xs font-semibold tabular-nums',
        good ? 'text-success-text bg-success-soft' : 'text-danger-text bg-danger-soft',
        className,
      )}
    >
      <Icon className="h-3 w-3" strokeWidth={2.5} />
      {formatDeltaPct(value)}
    </span>
  );
}

/** Rótulo chico + cifra grande (el interior de un KPI). */
export function Metric({
  label,
  value,
  sub,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <p className="text-2xs uppercase tracking-wide text-ink-faint">{label}</p>
      <p className="cifra mt-1 text-2xl">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-ink-muted">{sub}</p>}
    </div>
  );
}
